import React, { useContext, useState } from "react";
import "./coupon.css";
import { removecoupon } from "../../../../../../../../config/Services";
import { useSnackbar } from "../../../../../hooks/SnackbarProvider";
import { UserContext } from "../../../../../../../../App";
import { useSelector } from "react-redux";
import { getCouponState } from "../../../../redux/Reducers/couponReducer";
import { useDispatch } from "react-redux";
import { PosCustomButton } from "../../../../../../../../customComponents/PosCustomButton/PosCustomButton";
import { addcoupon } from "../../../../redux/Actions/couponActions";

export default function CouponUI({ data, locked = false, onRemoveSuccess }) {
  const showSnackbar = useSnackbar();
  const { setTotal, setCgst, setSgst, setCouponApplied, setCess } = useContext(UserContext);
  let cartId = localStorage.getItem("CartId");
  const [loader, setLoader] = useState(false);
  const [hidden, setHidden] = useState(false);
  const couponData = useSelector(getCouponState);
  const dispatch = useDispatch();
  const couponDataFromLocal = localStorage.getItem("cartCoupon")
    ? JSON.parse(localStorage.getItem("cartCoupon"))
    : {};

  const handleRemovecoupon = () => {
    setHidden(true);
    setLoader(true);
    removecoupon(cartId)
      .then((res) => {
        showSnackbar("Successfully coupon removed", "success");
        setTotal(res?.data?.data?.billing?.totalCartValue);
        localStorage.removeItem("cartCoupon");
        dispatch(addcoupon(null));
        setCouponApplied("0");
        onRemoveSuccess?.();
      })
      .catch((err) => {
        setHidden(false);
        showSnackbar(err?.response?.data?.message || err?.message, "error");
      })
      .finally(() => {
        setLoader(false);
      });
  };

  if (hidden) return null;
  return (
    <div className="coupon-wrapper">
      <div className="coupon-inner-wrapper">
        <div className="coupon-box">
          <div className="coupon-left">
            <div className="coupon-checkmark">
              <svg
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="white"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="20,6 9,17 4,12"></polyline>
              </svg>
            </div>
            <span className="coupon-text">{`Added ${
              data?.couponName || couponDataFromLocal?.couponName || "Coupon"
            }`}</span>
          </div>

          {!locked && (
            <PosCustomButton
              variant={"red-d"}
              loading={loader}
              title="Remove"
              onClickFunction={() =>
                handleRemovecoupon(data?.couponCode || couponDataFromLocal?.couponCode)
              }
            />
          )}
        </div>
      </div>
    </div>
  );
}
